
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IUserState } from '../../store/contract';

@Component
export default class OverviewMenu extends Vue {
    @State('user') userState: IUserState;

    get showMyTab() {
        return this.userState.user.isViewer && !this.userState.user.isFullViewer;
    }
}
